// extracted by mini-css-extract-plugin
export var modalFooter = "_n6-0";